import { Link } from "gatsby"
import React, { useState } from "react"
import SVGIcon from "../common/SVGIcon"
import { downloadAsset } from "../utility/asset_download"
import CheckLinkDomain from "../utility/current_domain"
import PopupSignup from "./popup-sign-up"
import PopupUpload from "./uploadPopup"
function Buttons(props) {
  const [popup, setPopup] = useState(false)
  // const [formSwitch, setFormSwitch] = useState(true)

  const togglePopUp = () => {
    setPopup(!popup)
    // setFormSwitch(true)
  }

  var properties = {
    style: props.style,
    className: `btn btn-${props.theme} ${
      props.arrow ? "arrow" : ""
    } ${props.active && "active"}`,
  }
  if (props.link) {
    properties = {
      ...properties,
      target: CheckLinkDomain(props.link) || !props.newTab ? "_self" : "_blank",
      [props.download ? "href" : "to"]: props.link,
      download: props.download ? true : false,
    }
  } else if (props.signupPopup) {
    properties = {
      ...properties,
      onClick: togglePopUp,
    }
  } else if (props.UploadPopup) {
    properties = {
      ...properties,
      onClick: togglePopUp,
    }
  } else if (props.downloadFile) {
    properties = {
      ...properties,
      onClick: () => downloadAsset(props.file, props.fileName),
    }
  } else {
    properties = {
      ...properties,
      type: props.type,
      onClick: props.onClick,
      id: props.id,
    }
  }
  return (
    <>
      {/* {props.signupPopup &&
        popup &&
        (formSwitch ? (
          <PopupSignupV2
            visibility={popup}
            togglePopup={togglePopUp}
            formSwitch={val => setFormSwitch(val)}
            formAPI={props.formOneAPI}
            hideFields={true}
            buttonText="SUBMIT"
            formTitle="Unlock the power of SuperOps. Enter your details to get started."
          />
        ) : (
          <PopupSignupV2
            visibility={popup}
            togglePopup={togglePopUp}
            formAPI={props.formTwoAPI}
            hideFields={false}
          />
        ))} */}

      {props.signupPopup && popup && (
        <PopupSignup
          visibility={popup}
          togglePopup={togglePopUp}
          formAPI={props.formAPI}
          disallowCommonDomains={props.disallowCommonDomains}
        />
      )}
      {props.UploadPopup && popup && (
        <PopupUpload
          visibility={popup}
          togglePopup={togglePopUp}
          title="Share Template"
        />
      )}

      {props.link ? (
        <Link {...properties}>{props.text}</Link>
      ) : (
        <button {...properties} disabled={props.disableButton}>
          {/* {props.loading ? '...': props.text} */}
          {props.text}
        </button>
      )}
    </>
  )
}
// Refersh Button Component !!!!!!{Only for devlopment}!!!!!!!
export function Refreshbtn() {
  const [buttonText, setButtonText] = useState("Preview")
  const [Active, setActive] = useState(
    sessionStorage.getItem("refreshbtn") ?? "active"
  )
  function refreshdata() {
    if (buttonText === "Preview") {
      var http = new XMLHttpRequest()
      var url = `/__refresh`
      var params = ""
      http.open("POST", url, true)

      //Send the proper header information along with the request
      http.setRequestHeader("Content-type", "application/json")

      http.onreadystatechange = function() {
        //Call a function when the state changes.
        if (http.readyState == 4 && http.status == 200) {
          setButtonText("Loading...")
          setTimeout(() => {
            setButtonText("Preview")
          }, 60000)
        }
      }
      http.send(params)
    }
  }
  function opendev() {
    if (Active === "active") {
      sessionStorage.setItem("refreshbtn", "")
      setActive(sessionStorage.getItem("refreshbtn"))
    } else {
      sessionStorage.setItem("refreshbtn", "active")
      setActive(sessionStorage.getItem("refreshbtn"))
    }
  }
  return (
    <div className="grpdev">
      <div className={`devoverlay ${Active}`}>
        <button
          className={`opendev ${Active != "" && "arrow"}`}
          onClick={opendev}
        >
          <SVGIcon name="arow-right" />
          {/* <img src="https://img.icons8.com/color/344/ffffff/right-squared.png" alt="arrowimg" /> */}
        </button>
        <button className="refreshbtn" onClick={refreshdata}>
          {buttonText === "Preview" && (
            <img
              src="https://img.icons8.com/material-sharp/344/ffffff/visible.png"
              alt="img"
            />
          )}
          {buttonText}
        </button>
      </div>
    </div>
  )
}

export default Buttons
